<script>
    import { fly } from 'svelte/transition';
    import { expoIn } from 'svelte/easing';
    
    export let delay = 0
    export let delayOut = null
    export let duration = 300
    export let durationOut = duration
    export let ready = true
    let delay_out = delayOut !== null ? delayOut : delay
</script>

{#if ready}
    <div class="FadeInFX" 
        in:fly={{ y: 20, duration: duration, delay: delay }} 
        out:fly={{ y: 20, duration: durationOut, delay: delay_out }}>
        <slot> </slot>
    </div>
{/if}

<style>
    
</style>